// AUTO-GENERATED by scripts/gen-custom-exports.mjs - Do not edit manually
//
// This file provides a single import path for custom components,
// eliminating preload warnings from try/catch dynamic imports.

// form-embed-form-handler
export { FormEmbedFormHandler } from '@/app/_components/empty-fallback'; // fallback

// form-embed-additional-content
export { FormEmbedAdditionalContent } from '@/app/_components/empty-fallback'; // fallback

// footer-default-additional-content
export { FooterAdditionalContentTop } from '@/app/_components/empty-fallback'; // fallback
export { FooterAdditionalContentBottom } from '@/app/_components/empty-fallback'; // fallback

// hero-advanced-additional-content
export { HeroAdvancedAdditionalContent } from '@/app/_components/empty-fallback'; // fallback

// link-resolvers
export { customLinkResolvers } from './link-resolvers'; // custom

// consent-manager
export { consentManagerAdapter } from './consent-manager'; // custom

// html-block-form-handler
export { HtmlBlockFormHandler } from '@/app/_components/empty-fallback'; // fallback
